export enum AccountTypeEnum {
  PersonalAccount = 0,
  BusinessAccount = 1,
}
